var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showWarning)?_c('div',{staticClass:"z-5 absoluteCenter"},[_vm._t("default")],2):_vm._e(),_c('Overlay',{attrs:{"show":_vm.showWarning}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }